function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.6472,
  cy: 27.4477,
  r: 26.8676,
  fill: "#F9AB15"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.1234 18.8943C30.6114 18.8943 31.8994 19.1423 32.9874 19.6383C34.0914 20.1343 34.9394 20.8383 35.5314 21.7503C36.1234 22.6623 36.4194 23.7423 36.4194 24.9903C36.4194 26.2223 36.1234 27.3023 35.5314 28.2303C34.9394 29.1423 34.0914 29.8463 32.9874 30.3423C31.8994 30.8223 30.6114 31.0623 29.1234 31.0623H25.7394V35.6943H21.8514V18.8943H29.1234ZM28.9074 27.8943C30.0754 27.8943 30.9634 27.6463 31.5714 27.1503C32.1794 26.6383 32.4834 25.9183 32.4834 24.9903C32.4834 24.0463 32.1794 23.3263 31.5714 22.8303C30.9634 22.3183 30.0754 22.0623 28.9074 22.0623H25.7394V27.8943H28.9074Z",
  fill: "white"
});

function SvgPaleo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaleo);
export default __webpack_public_path__ + "static/media/paleo.4f7b4d6e.svg";
export { ForwardRef as ReactComponent };